import axios from "axios";

let apiUrl = null;

export const getApiUrl = async () => {
  if (apiUrl) return apiUrl;
  
  try {
    // Fetch runtime configuration from server
    const response = await fetch("/api/config");
    const config = await response.json();
    apiUrl = config.apiUrl;
    return apiUrl;
  } catch (error) {
    // Fallback for local development or if config endpoint fails
    console.warn("Failed to fetch runtime config, using fallback:", error);
    apiUrl = process.env.REACT_APP_API_URL;
    return apiUrl;
  }
};

// Initialize axios instance with a placeholder baseURL
const api = axios.create({
  baseURL: "/", // Will be overridden by interceptor
});

// Request interceptor to set the correct baseURL before each request
api.interceptors.request.use(
  async (config) => {
    const baseURL = await getApiUrl();
    config.baseURL = baseURL;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config.url;
    if (error.response?.status === 401 && !url.toLowerCase().endsWith("auth")) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
